import React, { useEffect, useState } from "react";
import "./App.css";
import { AppBar, Container, Tab, Tabs, Typography } from "@mui/material";

import { BrowserRouter, Link, Switch, Route } from "react-router-dom";
import { Theme } from "@mui/material/styles";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import WikiSyntaxGenerator from "./components/WikiSyntaxGenerator";
import Footer from "./components/Footer";
import StreamingSchedule from "./components/StreamingSchedule";
import termAndPolicy from "./components/TermAndPolicy";

/// Workaround from https://mui.com/guides/migration-v4/
// it could be your App.tsx file or theme file that is included in your tsconfig.json

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}
/// end workaround

function App() {
  const [value, setValue] = useState(0);

  const handleChange = (event: any, data: any) => {
    setValue(data);
  };

  const firebaseConfig = {
    apiKey: "AIzaSyC9W6K7ACdY70SAmRssczxgkMgJc2wPtX8",
    authDomain: "vspo-wiki-app.firebaseapp.com",
    databaseURL: "https://vspo-wiki-app-default-rtdb.firebaseio.com",
    projectId: "vspo-wiki-app",
    storageBucket: "vspo-wiki-app.appspot.com",
    messagingSenderId: "234543276101",
    appId: "1:234543276101:web:722bea90b00e88f430832c",
    measurementId: "G-E7DG61DQ6Y",
  };
  const app = initializeApp(firebaseConfig);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const analytics = getAnalytics(app);

  useEffect(() => {
    const path = window.location.pathname;
    const s = "schedule";
    if (path.lastIndexOf(s) + s.length === path.length) {
      setValue(1);
    }
  }, []);

  const wikiSyntaxGenerator = React.useCallback(
    () => <WikiSyntaxGenerator firebaseApp={app} />,
    []
  );
  const streamingSchedule = React.useCallback(
    () => <StreamingSchedule firebaseApp={app} />,
    []
  );

  return (
    <div className="App">
      <AppBar position="static" elevation={3}>
        <Typography variant="h1">ぶいすぽ非公式wiki編集支援アプリ</Typography>
      </AppBar>
      <BrowserRouter>
        <Container>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            centered
          >
            <Tab
              label="ぶいすぽ非公式wiki用構文ジェネレータ"
              component={Link}
              to="/"
              value={0}
            />
            <Tab
              label="Youtube配信予定"
              component={Link}
              to="/schedule"
              value={1}
            />
          </Tabs>
        </Container>
        <Switch>
          <Route exact path="/" component={wikiSyntaxGenerator} />
          <Route exact path="/schedule" component={streamingSchedule} />
          <Route exact path="/term_and_policy" component={termAndPolicy} />
        </Switch>
      </BrowserRouter>
      <Footer page={value} />
    </div>
  );
}

export default App;
